import React from 'react';
import * as styles from './index.styles';

type StarProps = {
  fillBackground: string;
  fillStar: string;
  percentage?: number;
  size?: number;
  strokeColor: string;
  strokeWidth?: number;
};

export function Star({
  fillBackground,
  fillStar,
  percentage = 100,
  size = 20,
  strokeColor = '#000',
  strokeWidth = 4,
}: StarProps): JSX.Element {
  const getStarType = () => {
    const filledPercentage =
      percentage > 0 && percentage < 1 ? percentage * 100 : percentage;

    return Math.round(filledPercentage / 25);
  };

  const getFilledStarPolygonPoints = (type: number) => {
    switch (type) {
      case 1:
        return '22,57.2 22,22 0,25 0,25 15.9,40.5 12.1,62.3';
      case 2:
        return '22.1,21.9 0,25 0,25 15.9,40.5 12.1,62.3 32,52 32,1.7';
      case 3:
        return '41.9,21.9 32,1.7 22.1,21.9 0,25 0,25.1 15.9,40.5 12.1,62.3 32,52 41.9,57.2';
      default:
        return '';
    }
  };

  const starType = getStarType();
  const polygonPoints = getFilledStarPolygonPoints(starType);

  return (
    <span css={styles.star(size)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 64 64"
      >
        <title>Star</title>
        <polygon
          css={styles.polygonStyled(
            starType,
            fillStar,
            fillBackground,
            strokeColor,
            strokeWidth,
          )}
          points="64,25 41.9,21.9 32,1.7 22.1,21.9 0,25 15.9,40.5 12.1,62.3 32,52 51.9,62.3 48.1,40.5"
        />
        {polygonPoints.length && (
          <polygon points={polygonPoints} style={{ fill: fillStar }} />
        )}
      </svg>
    </span>
  );
}
